import React, { Component } from 'react';
import { navigateTo } from 'gatsby-link';
import { scrollLockOn, scrollLockOff } from '../../../utils/helper-functions';
import FormWebinar from '../../form/form-webinar';
import ReactFitText from 'react-fittext';
import styles from './modal-webinar.module.css';

class WebinarModal extends Component {
  constructor() {
    super();
    this.state = {
      allowWebinar: false,
      modalHeight: null,
    };
  }

  unlockContent = () => {
    scrollLockOff();
    navigateTo('/employerbranding-webinar');
  };

  setModalHeight = () => {
    let height = document.getElementById('webinar-modal').clientHeight;
  };

  componentDidMount() {
    scrollLockOn();
    this.setModalHeight();
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.setModalHeight);
    }
  }

  render() {
    const { allowWebinar, modalHeight } = this.state;
    return allowWebinar === false ? (
      <div className={styles.overlay}>
        <div
          id="webinar-modal"
          className={styles.modal}
          style={{ height: modalHeight, maxHeight: '100%' }}
        >
          <ReactFitText compressor={1} maxFontSize={26}>
            <h1 className={styles.title}>
              Instantly access our insights and solutions for creating a
              powerful employer brand.
            </h1>
          </ReactFitText>
          <ReactFitText compressor={3.35} minFontSize={16} maxFontSize={20}>
            <p className={styles.copy}>
              This one-hour on-demand webinar is full of insights and solutions
              that will help you build a powerful and authentic talent brand.
            </p>
          </ReactFitText>
          <ReactFitText compressor={3.35} minFontSize={16} maxFontSize={20}>
            <p className={styles.copy}>Fill in the form below to access:</p>
          </ReactFitText>
          <ReactFitText compressor={3.35} minFontSize={16} maxFontSize={18}>
            <ul>
              <li className={styles.listItem}>
                How to keep your employer brand from becoming just a tagline on
                a t-shirt
              </li>
              <li className={styles.listItem}>
                How to ensure you create a brand that resonates with the right
                talent
              </li>
              <li className={styles.listItem}>
                How to get internal buy-in for investing in an employer brand
              </li>
              <li className={styles.listItem}>And much more!</li>
            </ul>
          </ReactFitText>
          <div className={styles.formWrapper}>
            <FormWebinar formID={'3774'} unlock={this.unlockContent} />
          </div>
        </div>
      </div>
    ) : null;
  }
}

export default WebinarModal;



// WEBPACK FOOTER //
// ./src/components/modal/modal-webinar-employeebranding/index.js